import { useState } from "react";
import HistoryIcon from "@mui/icons-material/History";
import { Typography } from "@mui/material";
import { Button, Datagrid, DateField, FunctionField, SelectField, TextField, useRecordContext } from "react-admin";
import ConfirmModal from "server/components/Modals/ConfirmModal";
import dataProvider from "server/dataProvider";
import { depositsRequests } from "api/depositsApi";
import { DepositActionChoices } from "utils/choices";
import { useNotifyError } from "utils/useNotifyError";
import { settings } from "app";

// The history endpoint is paginated but the modal shows everything at once, so ask for a single generous page.
const HISTORY_PER_PAGE = 100;

const HistoryDialog = () => {
  const record = useRecordContext();
  const notifyError = useNotifyError();
  const [history, setHistory] = useState([]);

  const onOpen = async () => {
    try {
      const { data } = await dataProvider.customRequest(
        depositsRequests.getDepositHistory(record?.userUid),
        null,
        "GET",
        `?CurrentPage=1&PerPage=${HISTORY_PER_PAGE}`,
      );

      // History entries carry no id of their own — index them so the Datagrid has stable row keys.
      setHistory((data?.items ?? []).map((item, index) => ({ id: index, ...item })));
    } catch (err) {
      notifyError(err);
      return false;
    }
  };

  return (
    <ConfirmModal
      titleContent="История на депозита"
      dialogSize="md"
      isConfirmButton={false}
      closeTitle="Затвори"
      onOpen={onOpen}
      resetProps={() => setHistory([])}
      triggerButton={
        <Button
          label="Виж история"
          startIcon={<HistoryIcon />}
          size="small"
        />
      }
    >
      <Datagrid
        data={history}
        rowClick={false}
        bulkActionButtons={false}
        resource="depositHistory"
        empty={<Typography sx={{ p: 2 }}>Няма движения по депозита</Typography>}
        sx={{ ...settings.style.secondaryDatagrid, m: 2 }}
      >
        <DateField
          label="Дата"
          source="createdAt"
          emptyText="-"
          locales="bg-BG"
          sortable={false}
        />
        <FunctionField
          label="Сума"
          sortable={false}
          render={rec => Number(rec?.amount ?? 0).toFixed(2)}
        />
        <SelectField
          label="Действие"
          source="action"
          choices={DepositActionChoices}
          emptyText="-"
          sortable={false}
        />
        <TextField
          label="Задължение (id)"
          source="debtId"
          emptyText="-"
          sortable={false}
        />
      </Datagrid>
    </ConfirmModal>
  );
};

export default HistoryDialog;
